"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _store = require("@/api/store");
var _systemGroup = require("@/api/systemGroup");
var _index = _interopRequireDefault(require("@/components/Tinymce/index"));
var _logistics = require("@/api/logistics");
var _validate = require("@/utils/validate");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var defaultObj = [{
  image: '',
  price: null,
  cost: null,
  otPrice: null,
  stock: null,
  barCode: '',
  weight: 0,
  volume: 0
}];
var objTitle = {
  price: {
    title: '售价'
  },
  cost: {
    title: '成本价'
  },
  otPrice: {
    title: '原价'
  },
  stock: {
    title: '库存'
  },
  barCode: {
    title: '商品编号'
  },
  weight: {
    title: '重量（KG）'
  },
  volume: {
    title: '体积(m³)'
  }
};
var _default = exports.default = {
  name: 'taoBao',
  components: {
    Tinymce: _index.default
  },
  data: function data() {
    return {
      loading: false,
      formThead: Object.assign({}, objTitle),
      manyTabTit: {},
      manyTabDate: {},
      formValidate: null,
      form: 1,
      props2: {
        children: 'child',
        label: 'name',
        value: 'id',
        multiple: true,
        emitPath: false
      },
      checkboxGroup: [],
      //
      recommend: [],
      modal_loading: false,
      ManyAttrValue: [Object.assign({}, defaultObj[0])],
      // 多规格
      imgList: [],
      tempData: {
        page: 1,
        limit: 9999
      },
      shippingList: [],
      merCateList: [],
      images: '',
      url: '',
      modalPic: false,
      isChoice: '',
      isDisabled: false,
      ruleInline: {
        storeName: [{
          required: true,
          message: '请输入商品名称',
          trigger: 'blur'
        }],
        cateIds: [{
          required: true,
          message: '请选择商品分类',
          trigger: 'change',
          type: 'array',
          min: '1'
        }],
        unitName: [{
          required: true,
          message: '请输入单位',
          trigger: 'blur'
        }],
        tempId: [{
          required: true,
          message: '请选择运费模板',
          trigger: 'change',
          type: 'number'
        }],
        keyword: [{
          required: true,
          message: '请输入商品关键字',
          trigger: 'blur'
        }],
        attrValue: [{
          required: true,
          message: '请上传商品轮播图',
          type: 'array',
          trigger: 'change'
        }]
      },
      grid: {
        xl: 12,
        lg: 12,
        md: 12,
        sm: 24,
        xs: 24
      },
      copyConfig: {}
    };
  },
  created: function created() {
    this.goodsCategory();
  },
  computed: {
    attrValue: function attrValue() {
      var obj = Object.assign({}, defaultObj[0]);
      delete obj.image;
      return obj;
    },
    oneFormBatch: function oneFormBatch() {
      var obj = [Object.assign({}, defaultObj[0])];
      delete obj[0].barCode;
      return obj;
    }
  },
  watch: {
    'formValidate.attr': {
      handler: function handler(val) {
        this.watCh(val);
      },
      immediate: false,
      deep: true
    }
  },
  mounted: function mounted() {
    this.productGetTemplate();
    this.getCopyConfig();
    this.getGoodsType();
  },
  methods: {
    // 删除表格中的属性
    delAttrTable: function delAttrTable(index) {
      this.formValidate.attrValue.splice(index, 1);
    },
    getCopyConfig: function getCopyConfig() {
      var _this2 = this;
      (0, _store.copyConfigApi)().then(function (res) {
        _this2.copyConfig = res;
      });
    },
    onChangeGroup: function onChangeGroup() {
      this.checkboxGroup.includes('isGood') ? this.formValidate.isGood = true : this.formValidate.isGood = false;
      this.checkboxGroup.includes('isBenefit') ? this.formValidate.isBenefit = true : this.formValidate.isBenefit = false;
      this.checkboxGroup.includes('isBest') ? this.formValidate.isBest = true : this.formValidate.isBest = false;
      this.checkboxGroup.includes('isNew') ? this.formValidate.isNew = true : this.formValidate.isNew = false;
      this.checkboxGroup.includes('isHot') ? this.formValidate.isHot = true : this.formValidate.isHot = false;
    },
    // 批量添加
    batchAdd: function batchAdd() {
      // if (!this.oneFormBatch[0].pic || !this.oneFormBatch[0].price || !this.oneFormBatch[0].cost || !this.oneFormBatch[0].ot_price ||
      //     !this.oneFormBatch[0].stock || !this.oneFormBatch[0].bar_code) return this.$Message.warning('请填写完整的批量设置内容！');
      var _iterator = _createForOfIteratorHelper(this.formValidate.attrValue),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var val = _step.value;
          this.$set(val, 'image', this.oneFormBatch[0].image);
          this.$set(val, 'price', this.oneFormBatch[0].price);
          this.$set(val, 'cost', this.oneFormBatch[0].cost);
          this.$set(val, 'otPrice', this.oneFormBatch[0].otPrice);
          this.$set(val, 'stock', this.oneFormBatch[0].stock);
          this.$set(val, 'barCode', this.oneFormBatch[0].barCode);
          this.$set(val, 'weight', this.oneFormBatch[0].weight);
          this.$set(val, 'volume', this.oneFormBatch[0].volume);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    },
    watCh: function watCh(val) {
      var tmp = {};
      var tmpTab = {};
      this.formValidate.attr.forEach(function (o, i) {
        // tmp['value' + i] = {title: o.attrName}
        // tmpTab['value' + i] = ''
        tmp[o.attrName] = {
          title: o.attrName
        };
        tmpTab[o.attrName] = '';
      });
      this.formValidate.attrValue = this.attrFormat(val);
      this.manyTabTit = tmp;
      this.manyTabDate = tmpTab;
      this.formThead = Object.assign({}, this.formThead, tmp);
    },
    attrFormat: function attrFormat(arr) {
      var data = [];
      var res = [];
      return format(arr);
      function format(arr) {
        if (arr.length > 1) {
          arr.forEach(function (v, i) {
            if (i === 0) data = arr[i]['attrValue'];
            var tmp = [];
            data.forEach(function (vv) {
              arr[i + 1] && arr[i + 1]['attrValue'] && arr[i + 1]['attrValue'].forEach(function (g) {
                var rep2 = (i !== 0 ? '' : arr[i]['attrName'] + '_') + vv + '$&' + arr[i + 1]['attrName'] + '_' + g;
                tmp.push(rep2);
                if (i === arr.length - 2) {
                  var rep4 = {
                    image: '',
                    price: 0,
                    cost: 0,
                    otPrice: 0,
                    stock: 0,
                    barCode: '',
                    weight: 0,
                    volume: 0,
                    brokerage: 0,
                    brokerage_two: 0
                  };
                  rep2.split('$&').forEach(function (h, k) {
                    var rep3 = h.split('_');
                    if (!rep4['attrValue']) rep4['attrValue'] = {};
                    rep4['attrValue'][rep3[0]] = rep3.length > 1 ? rep3[1] : '';
                  });
                  // Object.values(rep4.attrValue).forEach((v, i) => {
                  //   rep4['value' + i] = v
                  // })
                  for (var attrValueKey in rep4.attrValue) {
                    rep4[attrValueKey] = rep4.attrValue[attrValueKey];
                  }
                  res.push(rep4);
                }
              });
            });
            data = tmp.length ? tmp : [];
          });
        } else {
          var dataArr = [];
          arr.forEach(function (v, k) {
            v['attrValue'].forEach(function (vv, kk) {
              dataArr[kk] = v['attrName'] + '_' + vv;
              res[kk] = {
                image: '',
                price: 0,
                cost: 0,
                otPrice: 0,
                stock: 0,
                barCode: '',
                weight: 0,
                volume: 0,
                brokerage: 0,
                brokerage_two: 0,
                attrValue: _defineProperty({}, v['attrName'], vv)
              };
              for (var attrValueKey in res[kk].attrValue) {
                res[kk][attrValueKey] = res[kk].attrValue[attrValueKey];
              }
            });
          });
          data.push(dataArr.join('$&'));
        }
        return res;
      }
    },
    // 获取运费模板；
    productGetTemplate: function productGetTemplate() {
      var _this3 = this;
      (0, _logistics.shippingTemplatesList)(this.tempData).then(function (res) {
        _this3.shippingList = res.list;
      });
    },
    // 删除图片
    handleRemove: function handleRemove(i) {
      this.formValidate.sliderImages.splice(i, 1);
      this.$forceUpdate();
    },
    // 选择主图
    checked: function checked(item, index) {
      this.formValidate.image = item;
    },
    // 商品分类；
    goodsCategory: function goodsCategory() {
      var _this4 = this;
      (0, _store.categoryApi)({
        status: -1,
        type: 1
      }).then(function (res) {
        _this4.merCateList = res;
      });
    },
    // 生成表单
    add: function add() {
      var _this5 = this;
      if (this.url) {
        // var reg = /(http|ftp|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?/;
        // if (!reg.test(this.soure_link)) {
        //   return this.$message.warning('请输入以http开头的地址！');
        // }
        this.loading = true;
        this.copyConfig.copyType == 1 ? (0, _store.copyProductApi)({
          url: this.url
        }).then(function (res) {
          var info = res.info;
          _this5.formValidate = {
            image: _this5.$selfUtil.setDomain(info.image),
            sliderImage: info.sliderImage,
            storeName: info.storeName,
            storeInfo: info.storeInfo,
            keyword: info.keyword,
            cateIds: info.cateId ? info.cateId.split(',') : [],
            // 商品分类id
            cateId: info.cateId,
            // 商品分类id传值
            unitName: info.unitName,
            sort: 0,
            isShow: 0,
            isBenefit: 0,
            isNew: 0,
            isGood: 0,
            isHot: 0,
            isBest: 0,
            tempId: info.tempId,
            attrValue: info.attrValue,
            attr: info.attr || [],
            selectRule: info.selectRule,
            isSub: false,
            content: _this5.$selfUtil.replaceImgSrcHttps(info.content),
            specType: info.attr.length ? true : false,
            id: info.id,
            giveIntegral: info.giveIntegral,
            ficti: info.ficti
          };
          if (info.isHot) _this5.checkboxGroup.push('isHot');
          if (info.isGood) _this5.checkboxGroup.push('isGood');
          if (info.isBenefit) _this5.checkboxGroup.push('isBenefit');
          if (info.isBest) _this5.checkboxGroup.push('isBest');
          if (info.isNew) _this5.checkboxGroup.push('isNew');
          var imgs = JSON.parse(info.sliderImage);
          var imgss = [];
          Object.keys(imgs).map(function (i) {
            imgss.push(_this5.$selfUtil.setDomain(imgs[i]));
          });
          _this5.formValidate.sliderImages = imgss;
          if (_this5.formValidate.attr.length) {
            _this5.oneFormBatch[0].image = _this5.$selfUtil.setDomain(info.image);
            for (var i = 0; i < _this5.formValidate.attr.length; i++) {
              _this5.formValidate.attr[i].attrValue = JSON.parse(_this5.formValidate.attr[i].attrValues);
            }
          }
          _this5.loading = false;
        }).catch(function () {
          _this5.loading = false;
        }) : (0, _store.importProductApi)({
          url: this.url,
          form: this.form
        }).then(function (res) {
          _this5.formValidate = {
            image: _this5.$selfUtil.setDomain(res.image),
            sliderImage: res.sliderImage,
            storeName: res.storeName,
            storeInfo: res.storeInfo,
            keyword: res.keyword,
            cateIds: res.cateId ? res.cateId.split(',') : [],
            // 商品分类id
            cateId: res.cateId,
            // 商品分类id传值
            unitName: res.unitName,
            sort: 0,
            isShow: 0,
            isBenefit: 0,
            isNew: 0,
            isGood: 0,
            isHot: 0,
            isBest: 0,
            tempId: res.tempId,
            attrValue: res.attrValue,
            attr: res.attr || [],
            selectRule: res.selectRule,
            isSub: false,
            content: res.content,
            specType: res.attr.length ? true : false,
            id: res.id,
            giveIntegral: res.giveIntegral,
            ficti: res.ficti
          };
          var imgs = JSON.parse(res.sliderImage);
          var imgss = [];
          Object.keys(imgs).map(function (i) {
            imgss.push(_this5.$selfUtil.setDomain(imgs[i]));
          });
          _this5.formValidate.sliderImages = imgss;
          if (_this5.formValidate.attr.length) {
            _this5.oneFormBatch[0].image = _this5.$selfUtil.setDomain(res.image);
            for (var i = 0; i < _this5.formValidate.attr.length; i++) {
              _this5.formValidate.attr[i].attrValue = JSON.parse(_this5.formValidate.attr[i].attrValues);
            }
          }
          _this5.loading = false;
        }).catch(function () {
          _this5.loading = false;
        });
      } else {
        this.$message.warning('请输入链接地址！');
      }
    },
    // 提交
    handleSubmit: (0, _validate.Debounce)(function (name) {
      var _this6 = this;
      var pram = JSON.parse(JSON.stringify(this.formValidate));
      // this.formValidate.attr.length ? this.formValidate.attrValue = this.ManyAttrValue : this.formValidate.attrValue = []
      pram.attr.forEach(function (item) {
        item.attrValues = item.attrValue.join(",");
      });
      pram.cateId = pram.cateIds.join(',');
      pram.sliderImage = JSON.stringify(pram.sliderImages);
      pram.attrValue.forEach(function (itemData) {
        itemData.attrValue = JSON.stringify(itemData.attrValue);
      });
      this.$refs[name].validate(function (valid) {
        if (valid) {
          _this6.modal_loading = true;
          (0, _store.productCreateApi)(pram).then(/*#__PURE__*/function () {
            var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(res) {
              return _regenerator().w(function (_context) {
                while (1) switch (_context.n) {
                  case 0:
                    _this6.$message.success('新增成功');
                    _this6.$emit('handleCloseMod', false);
                    _this6.modal_loading = false;
                  case 1:
                    return _context.a(2);
                }
              }, _callee);
            }));
            return function (_x) {
              return _ref.apply(this, arguments);
            };
          }()).catch(function () {
            _this6.modal_loading = false;
          });
        } else {
          if (!pram.storeName || !pram.cateId || !pram.keyword || !pram.unitName || !pram.image) {
            _this6.$message.warning("请填写完整商品信息！");
          }
        }
      });
    }),
    // 点击商品图
    modalPicTap: function modalPicTap(tit, num, i) {
      var _this = this;
      this.$modalUpload(function (img) {
        if (tit === '1' && !num) {
          _this.formValidate.image = img[0].sattDir;
          _this.OneattrValue[0].image = img[0].sattDir;
        }
        if (tit === '2' && !num) {
          if (img.length > 10) return this.$message.warning("最多选择10张图片！");
          if (img.length + _this.formValidate.sliderImages.length > 10) return this.$message.warning("最多选择10张图片！");
          img.map(function (item) {
            _this.formValidate.sliderImages.push(item.sattDir);
          });
        }
        if (tit === '1' && num === 'dan') {
          _this.OneattrValue[0].image = img[0].sattDir;
        }
        if (tit === '1' && num === 'duo') {
          _this.formValidate.attrValue[i].image = img[0].sattDir;
        }
        if (tit === '1' && num === 'pi') {
          _this.oneFormBatch[0].image = img[0].sattDir;
        }
      }, tit, 'store');
    },
    handleDragStart: function handleDragStart(e, item) {
      this.dragging = item;
    },
    handleDragEnd: function handleDragEnd(e, item) {
      this.dragging = null;
    },
    // 首先把div变成可以放置的元素，即重写dragenter/dragover
    handleDragOver: function handleDragOver(e) {
      // e.dataTransfer.dropEffect="move";//在dragenter中针对放置目标来设置!
      e.dataTransfer.dropEffect = 'move';
    },
    handleDragEnter: function handleDragEnter(e, item) {
      // 为需要移动的元素设置dragstart事件
      e.dataTransfer.effectAllowed = 'move';
      if (item === this.dragging) {
        return;
      }
      var newItems = _toConsumableArray(this.formValidate.slider_image);
      var src = newItems.indexOf(this.dragging);
      var dst = newItems.indexOf(item);
      newItems.splice.apply(newItems, [dst, 0].concat(_toConsumableArray(newItems.splice(src, 1))));
      this.formValidate.slider_image = newItems;
    },
    getGoodsType: function getGoodsType() {
      var _this7 = this;
      /** 让商品推荐列表的name属性与页面设置tab的name匹配**/
      (0, _systemGroup.goodDesignList)({
        gid: 70
      }).then(function (response) {
        var list = response.list;
        var arr = [];
        var arr1 = [];
        var listArr = [{
          name: '是否热卖',
          value: 'isHot'
        }];
        var typeLists = [{
          name: '',
          value: 'isGood',
          type: '2'
        },
        //精品推荐1  热门榜单2 首发新品3 促销单品4
        {
          name: '',
          value: 'isBenefit',
          type: '4'
        }, {
          name: '',
          value: 'isBest',
          type: '1'
        }, {
          name: '',
          value: 'isNew',
          type: '3'
        }];
        list.forEach(function (item) {
          var obj = {};
          obj.value = JSON.parse(item.value);
          obj.id = item.id;
          obj.gid = item.gid;
          obj.status = item.status;
          arr.push(obj);
        });
        arr.forEach(function (item1) {
          var obj1 = {};
          obj1.name = item1.value.fields[1].value;
          obj1.status = item1.status;
          obj1.type = item1.value.fields[3].value;
          arr1.push(obj1);
        });
        typeLists.forEach(function (item) {
          arr1.forEach(function (item1) {
            if (item.type == item1.type) {
              listArr.push({
                name: item1.name,
                value: item.value,
                type: item.type
              });
            }
          });
        });
        _this7.recommend = listArr;
      });
    }
  }
};